/* unplugin-vue-components disabled */import { render } from "./MaterialItem.vue?vue&type=template&id=84a2872c&scoped=true&ts=true"
import script from "./MaterialItem.vue?vue&type=script&lang=ts"
export * from "./MaterialItem.vue?vue&type=script&lang=ts"

import "./MaterialItem.vue?vue&type=style&index=0&id=84a2872c&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a2872c"]])

export default __exports__